"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAddress = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
var _constants = require("../../utils/constants");
var _helper = require("../../utils/helper");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const SelectAddress = exports.SelectAddress = /*#__PURE__*/(0, _react.memo)(() => {
  const activeBuildings = (0, _reactRedux.useSelector)(_selectors.selectActiveBuilding);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  /** @todo change translation number to key */
  const {
    9: tBuildings
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const buildings = (0, _reactRedux.useSelector)(_selectors.selectBuildings);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [options, setOptions] = (0, _react.useState)([]);
  const updateSelector = (0, _react.useCallback)((_, value) => {
    dispatch((0, _actions.setActiveBuilding)(value));
  }, [dispatch]);
  (0, _react.useEffect)(() => {
    if (buildings) {
      setOptions(buildings.map((group, index) => {
        var _group$3, _group$4, _group$5;
        if (group.length > 1) {
          var _group$, _group$2;
          return {
            value: ((_group$ = group[0]) === null || _group$ === void 0 ? void 0 : _group$.id) || index,
            label: "".concat(tV((_group$2 = group[0]) === null || _group$2 === void 0 ? void 0 : _group$2.thingBuildingStreet), " ").concat(group.map(b => " ".concat(tV(b.thingBuildingHouseNumber))))
          };
        }
        return {
          value: ((_group$3 = group[0]) === null || _group$3 === void 0 ? void 0 : _group$3.id) || index,
          label: "".concat(tV((_group$4 = group[0]) === null || _group$4 === void 0 ? void 0 : _group$4.thingBuildingStreet), " ").concat(tV((_group$5 = group[0]) === null || _group$5 === void 0 ? void 0 : _group$5.thingBuildingHouseNumber))
        };
      }));
    }
  }, [buildings, tV]);
  const hideSelector = options.length <= 1;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _objectSpread({
      transition: _constants.styles.transitionType.secondary,
      '> div': {
        width: '100%'
      }
    }, hideSelector ? _helper.hiddenSelectorSx : {})
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Select, {
    value: activeBuildings,
    updateSelector: updateSelector,
    item: {
      defaultValue: tBuildings,
      type: 'select'
    },
    options: options,
    variant: "secondary"
  }));
});